import './bootstrap';
/**
 * Sets up error logging
 */
import '@base/base';

// Import modules...
import Vue from 'vue';

import {App, plugin as inertiaPlugin} from '@inertiajs/inertia-vue'
import {DropdownPlugin, FormSelectPlugin, PaginationPlugin, TabsPlugin} from "bootstrap-vue";
import {provideToast} from "vue-toastification/composition";
import "vue-toastification/dist/index.css";
import {initInertia} from "./Helpers/useInertia";
import {InertiaProgress} from "@inertiajs/progress";
import {UserEntityInterface} from "./tool.types";
import * as Sentry from "@sentry/vue";

Vue.use(inertiaPlugin);

/**
 * If shared with frontend include them in base
 */
Vue.use(DropdownPlugin);
Vue.use(PaginationPlugin);
Vue.use(FormSelectPlugin);
Vue.use(TabsPlugin);

const el = document.getElementById('app');
// @ts-ignore
const pageData = JSON.parse(el.dataset.page);

if (typeof pageData.user !== 'undefined' && typeof pageData.user.email !== 'undefined') {
    Sentry.setUser({email: pageData.user.email});
}

const app = new Vue({
    render: h => h(App, {
        props: {
            initialPage: pageData,
            resolveComponent: (name: string) => {
                // let parts = name.split('/');
                // let type = parts[0];
                // if(type.startsWith('@')) {
                //     let moduleName = type.replace('@', '');
                //     const pagePath = name.replace(`${moduleName}/`, '');
                //     return require(`../../../../../Modules/${moduleName}/Resources/assets/js/Pages/${pagePath}`).default;
                // }
                return require(`./Pages/${name}`).default;
            }
        },
    }),
    setup(props) {
        provideToast({timeout: 3000});
    },

}).$mount('#app');

InertiaProgress.init({color: '#4caf50', showSpinner: true});

// @ts-ignore
initInertia(Vue.prototype.$inertia);

interface PageProps {
    user: UserEntityInterface,
    billing_trial_ends_at?: string;
}

// @ts-ignore
interface InertiaEventType extends Event {
    detail: {
        page: {
            props: PageProps & {
                errors: unknown,
            }
        }
    }
}

// @ts-ignore
document.addEventListener('inertia:success', (event: InertiaEventType) => {
    if ((window as any).woopra) {
        (window as any).woopra.track();
    }
});


